import { type FormEvent, type ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { ApiError } from '../../lib/http';
import { BASE_PATH } from '../lib/basePath';
import { TelaAuthPortal } from '../componentes/TelaAuthPortal';
import { BlocoAviso, Botao, Campo } from '../componentes/ui';

/**
 * Login do portal (UX §0): o cliente entra com o **telefone** e a senha que
 * criou no primeiro acesso. A API normaliza o telefone para E.164 (CLAUDE.md
 * regra 4) — o front manda o que foi digitado.
 */
export function PortalLogin(): ReactNode {
  const { entrar } = useAuth();
  const [telefone, setTelefone] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const aoEnviar = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(telefone.trim(), senha);
      // o roteamento raiz por papel decide para onde ir (Home ou painel)
      window.location.assign(`${BASE_PATH}/`);
    } catch (err) {
      setErro(
        err instanceof ApiError && !err.ehRede
          ? 'Telefone ou senha incorretos.'
          : 'Não foi possível conectar. Verifique a internet e tente de novo.',
      );
      setEnviando(false);
    }
  };

  return (
    <TelaAuthPortal>
      <form onSubmit={(e) => void aoEnviar(e)} className="flex flex-col gap-5" noValidate>
        <p className="tipo-corpo text-tinta">Entre para ver seu código e seus brindes.</p>
        {erro && <BlocoAviso>{erro}</BlocoAviso>}
        <Campo
          rotulo="Telefone"
          type="tel"
          inputMode="tel"
          autoComplete="username"
          autoFocus
          value={telefone}
          onChange={(e) => setTelefone(e.target.value)}
        />
        <Campo
          rotulo="Senha"
          type="password"
          autoComplete="current-password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
        <Botao type="submit" variante="primario" carregando={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </Botao>
        <Link to="/recuperar" className="tipo-nota text-acento-texto underline">
          Esqueci minha senha
        </Link>
      </form>
    </TelaAuthPortal>
  );
}
